import { render } from "./Tarjeta.vue?vue&type=template&id=62160a85"
import script from "./Tarjeta.vue?vue&type=script&lang=js"
export * from "./Tarjeta.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__